export default __webpack_public_path__ + "a47f3f9a72cb19cfb13da43f04861159.svg";